angular.module('impactx.sidebar').controller('MenuSidebarCtrl', [
    '$workspace',
    'sidebarShow',
    'AppConfiguration',
    'TranslationService',
    'LegalLinking',
    '$location',
    'ToolbarService',
    '$scope',
    MenuSidebarController
]);

function MenuSidebarController($workspace, sidebarShow, AppConfiguration, TranslationService, LegalLinking, $location, ToolbarService, $scope) {
    var self = this;
    self.showBoxShadow = false;
    self.currentWorkspace = {};
    self.currentYear = AppConfiguration.get('copyRightYear');
    self.smallMenuEnabled = AppConfiguration.get('smallMenuEnabled');
    self.disableSmallMenuChange = AppConfiguration.get('disableSmallMenuChange');
    self.isToolbarHidden = ToolbarService.isToolbarHidden;
    self.removeCopyRight = AppConfiguration.get('removeCopyRight');

    self.$onInit = function () {
        TranslationService.onInitialization().then(function () {
            self.trns = {
                smallMenuHint: TranslationService.get('smallMenuHint'),
                hint: TranslationService.get('hint'),
                terms: TranslationService.get('terms'),
                imprint: TranslationService.get('imprint'),
                privacyPolicy: TranslationService.get('privacyPolicy')
            }
        });

        self.config = {
            imprintURL: AppConfiguration.get('imprintURL'),
            privacyPolicy: AppConfiguration.get('privacyPolicy'),
            generalTerms: AppConfiguration.get('generalTerms'),
            smallMenuEnabled: AppConfiguration.get('smallMenuEnabled'),
            removeCopyRight: AppConfiguration.get('removeCopyRight')
        };
    };

    self.getCurrentWorkspace = function () {
        self.currentWorkspace = $workspace.getCurrentWorkspace();
        return self.currentWorkspace;
    };

    self.showMenuSidebar = function () {
        var isOpen = sidebarShow.isOpen();
        if (!isOpen) {
            self.showBoxShadow = false;
        }
        return isOpen;
    };

    self.toggleIsHidden = function () {
        return sidebarShow.toggleIsHidden();
    }

    self.isShop = function () {
        return self.getCurrentWorkspaceKey() === 'shop';
    };

    self.isContent = function () {
        return self.getCurrentWorkspaceKey() === 'content';
    };

    self.isMonitor = function () {
        return self.getCurrentWorkspaceKey() === 'monitor';
    };

    self.isAdmin = function () {
        return self.getCurrentWorkspaceKey() === 'admin';
    };

    self.isAdmin = function () {
        return self.getCurrentWorkspaceKey() === 'system';
    };

    self.getCurrentWorkspaceKey = function () {
        return impactX.isDefined(self, 'currentWorkspace.key');
    };

    self.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };

    self.isActive = function (path) {
        path = "/" + path;
        return $location.path() === path;
    };

    $scope.onScroll = function (event, scrollTop) {
        self.showBoxShadow = scrollTop > 0;
    };
}